import ui from 'styles/ui.module.css';

// Aviso para DENTRO de un modal (pieza compartida; regla R140: no se copia el estilo en cada modal). Fondo SÓLIDO (el de `.alert-*`
// es translúcido y se mezclaría con lo de abajo), fijo arriba mientras el cuerpo se desplaza y con role="alert" para que un lector de
// pantalla lo anuncie (role="status" si solo informa). `tipo`: 'danger' (por defecto) | 'warning' | 'info'. Con `onClick` el aviso se cierra al tocarlo.
const TONO = { danger: ui.avisoPeligro, warning: ui.avisoAdvertencia, info: ui.avisoInformacion };

export default function AvisoModal({ tipo = 'danger', className = '', onClick, children }) {
  return (
    <div role={tipo === 'info' ? 'status' : 'alert'} onClick={onClick}
      className={`alert ${TONO[tipo] || ui.avisoPeligro} ${ui.avisoFijo} ${onClick ? ui.avisoCerrable : ''} ${className}`.replace(/\s+/g, ' ').trim()}>
      {children}
    </div>
  );
}
